module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/FireHDLogo_a640792.png";